import appLS from '../../constants/local-storage';
import api from '../../services/apiService'

const products = "/products";

const purchase = "/elsa/purchases";

const getAllProducts = () => api.elsa.get(products);

const getAllPurchases = () => api.framework.get(purchase);

const updatePurchase = (elsaProduct) => api.framework.put(purchase, elsaProduct);

const getElsaIntegrations = () => getAllProducts().then(async (products) => {
  // checks for already integrated products.
  const user = localStorage.getItem(appLS.user);
  const companyKey = localStorage.getItem(appLS.companyKey);

  if (companyKey && user && (JSON.parse(user).expires_at > (new Date().getTime() / 1000))) {
    products.data = await getAllPurchases().then((purch) => products.data.map(inte => {
      inte['_isBought'] = purch.data.some(pur => pur.ProductID === inte.id);
      return inte;
    })).catch(e => console.log(e));
  }
  return products.data;
}).catch((err) => {
  throw new Error(err);
});

const getFrameworkPurchases = () => getAllPurchases();

const updateElsaPurchase = (elsaProduct) => updatePurchase(elsaProduct);

export { updateElsaPurchase, getElsaIntegrations, getFrameworkPurchases };